module.exports = __webpack_public_path__ + "static/media/logo-forbes.e5c174a0.png";